import { render, staticRenderFns } from "./EventDetail.vue?vue&type=template&id=ecd08476&scoped=true"
import script from "./EventDetail.vue?vue&type=script&lang=js"
export * from "./EventDetail.vue?vue&type=script&lang=js"
import style0 from "./eventDetail.css?vue&type=style&index=0&id=ecd08476&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecd08476",
  null
  
)

export default component.exports